import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import Vant from 'vant';
import { Lazyload } from 'vant';
import 'vant/lib/index.css';
import './css/common.css';


import VueWechatTitle from 'vue-wechat-title'
import VConsole from 'vconsole';
if(process.env.NODE_ENV == "development") {

  new VConsole();
}
import MobileDetect from './js/mobile-detect.min'

const  md = new MobileDetect(window.navigator.userAgent);
const headerParams = {
    'Terminal-System': md.os(),
    'Terminal-Device': md.mobile(),
    'Terminal-Browser': md.userAgent(),
    "Terminal-Program": "H5"
}
localStorage.setItem('headerParams', JSON.stringify(headerParams))

Vue.config.ignoredElements = ['wx-open-launch-weapp']
// import * as VueGoogleMaps from 'vue2-google-maps'
import { changeObj } from '@/utils/filter'
import {timeToDate} from '@/utils/date-format';
// import Clipboard from 'v-clipboard'
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)
// Vue.use(Clipboard)

Vue.use(Vant);
Vue.use(Lazyload)
Vue.use(VueWechatTitle)

Vue.config.productionTip = false;
Vue.prototype.$changeObj = changeObj;

// Vue.use(VueGoogleMaps, {
//   load: {
//     key: "AIzaSyBXRnHc9OMF9Z9lLJ5zxKlYK7e9kbzY_1w",
//     libraries: "places",
//     language: 'en-US'
//   }
// });
Vue.filter('timeToDate', timeToDate)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
